import { CounselorReferenceField } from "./CounselorReferenceField";
import CounselorsEdit from "./CounselorsEdit";
import CounselorsList from "./CounselorsList";

export default {
  CounselorReferenceField: CounselorReferenceField,
  list: CounselorsList,
  edit: CounselorsEdit,
};
